export default __webpack_public_path__ + "static/media/MNeutral.9be521ef.svg";